import React from 'react';
import styled from 'styled-components';
import LeftContent from './LeftContent';
import RightContent from './RightContent';

const MiddleContentWrapper = styled.div`
  display: flex;
  height: 85%;
  margin: 5px 0;
`;

const Separator = styled.div`
  width: 2px;
  background-color: yellow;
`;

const MiddleContent = () => {
  return (
    <MiddleContentWrapper>
      <LeftContent />
      <Separator />
      <RightContent />
    </MiddleContentWrapper>
  );
};

export default MiddleContent;

